// REF-6708: the ONE thing a catch block may take off a caught error when it logs to the console.
//
// A rejected request from the shared HTTP client is an axios error, and its `config` carries the
// request body (a password, the Google `google_token`), the URL (an invite or reset token) and
// `headers.Authorization` (the session bearer token). Console output reaches Sentry breadcrumbs
// and Session Replay, so a catch block never logs the error object, its config, headers, body,
// URL or message. If a diagnostic is genuinely useful, log a fixed message plus this status:
//
//   .catch((error) => {
//     console.error("Failed to accept invite", { status: httpStatusOf(error) });
//   });
//
// It returns an integer HTTP status (100–599) or `undefined` — never a string, message or body —
// and reads the error once inside a try, so a hostile or odd value cannot throw or leak through it.
export const httpStatusOf = (error: unknown): number | undefined => {
  try {
    const status = (error as { response?: { status?: unknown } } | null | undefined)?.response?.status;

    return typeof status === "number" && Number.isInteger(status) && status >= 100 && status <= 599 ? status : undefined;
  } catch {
    return undefined;
  }
};
